// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Projects_projectsContainer__iNipK"};